module.exports = __webpack_public_path__ + "img/calendar-check-fill.8ca425de.svg";